import React from 'react'

const generalErrorMessage = (
  <>
    Sorry, we are unable to proceed with your request online. Please contact our Customer Service at{' '}
    <a href="tel:1800889933">1 800 889 933</a> or <a href="tel:+60321707300">+603 2170 7300</a>,
    operating hours 8:30am - 5.00pm (Monday to Friday) excluding public holidays. Alternatively, you
    may email your vehicle details (car plate and NRIC) to{' '}
    <a href="mailto:customer@bsompo.com.my">customer@bsompo.com.my</a> for further assistance.
  </>
)

export default {
  id: 'BM',
  travelBenefits: {
    title: 'Manfaat Insurans Perjalanan Secure Travel',
    desc:
      'Sama ada komplikasi COVID-19 atau kesulitan perjalanan biasa, dalam atau luar negara, kami akan berada di sana untuk melindungi anda.',
    benefit1: 'Repatriasi & Pemindahan Perubatan Kecemasan',
    benefit2: 'Terbang kembali dan dapatkan rawatan perubatan dalam keselesaan negara asal anda.',
    benefit3:
      'Rehat dan mudahkan perjalanan walaupun terdapat perbelanjaan perubatan yang tidak dijangka',
    benefit4: 'Pembatalan yang tidak dijangka? Biar kami fikirkan untuk anda!',
    benefit5: 'Kecualikan kos kuarantin COVID-19 daripada senarai kebimbangan anda.',
    benefit6:
      'Liputan gangguan perjalanan atau perjalanan dipendekkan kerana kecemasan? Jangan risau, kami bersedia untuk anda.',
  },
  keyCoverage: {
    title: 'Liputan Utama',
    desc:
      'Ketahui pelan insurans perjalanan terbaik di bawah yang sesuai dengan keperluan perjalanan anda. Dapatkan sebut harga sekarang untuk perlindungan insurans perjalanan penuh.',
    eliteA: 'Elite A',
    eliteB: 'Elite B',
    eliteC: 'Elite C',
    coverage1: 'PERBELANJAAN PERUBATAN & LAIN-LAIN',
    coverage1sub1_1: 'Perbelanjaan Perubatan, Hospital',
    coverage1sub1_2: 'Lain-lain',
    coverage1Dropdown1: 'Perbelanjaan Perubatan, Hospital & Lain-lain',
    coverage2: 'KEMALANGAN DIRI',
    coverage2sub1: 'Kemalangan Diri',
    coverage2Dropdown1: 'Hilang Upaya Menyeluruh dan Kekal',
    coverage3: 'REPATRIASI & PEMINDAHAN PERUBATAN KECEMASAN',
    coverage3sub1: 'Repatriasi & Pemindahan Perubatan Kecemasan',
    coverage3Dropdown1: 'Repatriasi Jenazah*',
    coverage4_1: 'KESULITAN PERJALANAN & MANFAAT LAIN BERKAITAN PERJALANAN',
    coverage4_2: 'Termasuk dalam Perlindungan',
    coverage4_3: 'Tidak masuk dalam Perlindungan',
    inclusive: ' (Termasuk Perlindungan COVID-19)',
    unlimited: 'Tanpa Had'
  },
  highlights: {
    travelHighlights: 'Sorotan Insurans Perjalanan',
    desc: 'Ketahui lebih lanjut tentang tarikan dan aktiviti terkini kami',
    highlight1: 'Insurans Perjalanan Malaysia',
    highlight1desc: 'Panduan Terbaik untuk Insurans Perjalanan',
    highlight2: 'Cara Membeli Insurans Perjalanan Dalam Talian',
    hightlight2desc: 'Pembelian mudah dalam 6 langkah.',
    highlight3: 'SOMPO TravelSafe - Soalan Lazim (Soalan Lazim)',
    highlight3desc: 'Perlukan bantuan? Kami sedia membantu anda.',
    readMore: 'Baca Lagi',
  },
  moreInsurance: {
    title: 'Meliputi setiap bahagian setiap hari',
    desc: 'Ketahui lebih lanjut tentang produk insurans yang kami tawarkan',
    more1Title: 'Insurans Kereta',
    more1Sub1: 'Pelan ansuran 0% faedah sehingga 12 bulan.',
    more1Sub2: 'Percuma polisi semua pemandu, tiada pencalonan diperlukan.',
    more1Sub3_1: 'Pembaharuan insurans kereta',
    more1Sub3_2: 'dalam talian dengan kemas kini status JPJ segera.',
    more1Sub4: 'Bantuan Tepi Jalan 24 Jam.',
    more2Title: 'Insurans Motosikal',
    more2Sub1: 'Dapatkan sebut harga segera dalam talian dalam 1 minit.',
    more2Sub2:
      'Kemas kini automatik kepada sistem JPJ sebaik sahaja polisi insurans telah diperbaharui.',
    more2Sub3: 'Harga yang disemak dengan kadar premium yang berpatutan.',
    more2Sub4: 'Perjalanan pembelian mudah dengan sistem 100% selamat dan terjamin.',
    more3Title: 'Insurans Pendapatan Hospital',
    more3Sub1: 'Premium serendah RM0.29 sehari.',
    more3Sub2: 'Perlindungan COVID-19 dengan elaun hospital sekaligus sehingga RM5,000.',
    more3Sub3: 'Manfaat tunai harian sehingga maksimum RM18,000.',
    more3Sub4: 'Proses pendaftaran tanpa kerumitan, tiada pengisytiharan kesihatan diperlukan.',
    getQuote: 'Dapatkan Sebut Harga',
  },
  travelInsurance: {
    title: 'Travel Insurance Malaysia',
    desc1:
      'SOMPO TravelSafe ialah insurans perjalanan ke luar negara dan domestik Malaysia. Kami menawarkan perlindungan insurans perjalanan komprehensif yang dipertingkatkan dengan manfaat COVID-19 untuk anda dan keluarga anda untuk melindungi daripada sebarang kecemasan perjalanan, kesulitan perjalanan, pembatalan penerbangan, kelewatan penerbangan, komplikasi COVID-19 seperti perbelanjaan perubatan dan elaun kuarantin, juga termasuk perlindungan orang lain, komplikasi perubatan atau kesihatan semasa perjalanan supaya anda dapat menikmati percutian anda dengan tenang.',
    desc2:
      'Anda boleh membeli SOMPO TravelSafe - insurans perjalanan Malaysia melalui portal dalam talian kami dalam masa 2 minit pada harga yang berpatutan. Dengan satu panggilan telefon, bantuan perjalanan ke seluruh dunia 24/7 kami sedia membantu untuk sebarang kecemasan di mana sahaja anda berada.',
    desc3:
      'Jangan terkandas kerana risiko daripada kejadian yang tidak dijangka. Jadi, dapatkan sebut harga dan beli insurans perjalanan Malaysia dalam talian sebelum perjalanan anda yang seterusnya.',
    title2: 'Insurans Perjalanan SOMPO TravelSafe',
    desc4:
      'Lapangan dunia kini berbuka semula dan melancong di tengah-tengah pandemik COVID-19 telah menjadi kebiasaan baharu. Dengan SOMPO TravelSafe, anda kini boleh melancong di peringkat antarabangsa atau domestik dengan ketenangan fikiran yang mutlak. Nikmati perlindungan perjalanan yang komprehensif sehingga RM500,000 dan perlindungan terhadap komplikasi berkaitan COVID-19* – semuanya dalam satu insurans perjalanan yang melindungi setiap perjalanan anda. Dunia menanti.',
    desc5: '*Hanya terpakai kepada pengembara yang mendapatkan vaksin sepenuhnya.',
  },
  mailQuote: {
    mail: 'Sila masukkan alamat e-mel di bawah untuk mendapatkan sebut harga anda',
    sendMail: 'Hantar e-mel',
    mailQuote2:
      "Dengan mengklik butang 'Hantar e-mel', anda telah membaca dan bersetuju untuk menerima",
    mailQuote3: ' kami',
    privacyNotice: 'Notis Privasi',
    email: 'E-mel',
    successQuote: 'Sebut harga anda telah dihantar ke e-mel yang diberikan.',
    failedQuote: 'Penghantaran e-mel gagal ketika cuba menghantar sebut harga anda!',
  },
  elitePlan: {
    foundPlans: 'Kami menemui 3 pelan yang paling sesuai dengan anda.',
    eliteA: 'Elite A',
    eliteB: 'Elite B',
    eliteC: 'Elite C',
    totalPrice: 'Jumlah Harga untuk',
    adult: 'Dewasa',
    adults: 'Dewasa',
    child: 'Kanak',
    children: 'Kanak-kanak',
    buyNow: 'Beli Sekarang',
    limitPerPerson: 'Had Setiap Orang',
    upTo70Years: 'Sehingga 70 tahun',
    above70Years: '70 tahun ke atas',
    perDay: 'Sehari',
    perIndividual: 'Setiap Individu',
    planCoverage1: 'PERBELANJAAN PERUBATAN & LAIN-LAIN',
    coverage1sub1: 'Perbelanjaan Perubatan, Hospital & Lain-lain',
    coverage1sub2: 'Perubatan Alternatif*',
    coverage1sub3_1: 'Manfaat Penjagaan Simpati',
    coverage1sub3_2: '(atas sebab Anda dimasukkan ke dalam hospital) *',
    coverage1sub4_1: 'Manfaat Penjagaan Simpati',
    coverage1sub4_2: '(atas sebab kematian Anda) *',
    coverage1sub5_1: 'Rawatan Perubatan di Malaysia',
    coverage1sub5_2: '* Rawatan susulan dalam tempoh 60 hari selepas pulang ke Malaysia.',
    coverage1sub6: 'Manfaat Penjagaan Anak*',
    coverage1sub7: 'Elaun Hospital',
    coverage1sub8: 'Elaun Kuarantin Luar Negara Kerana COVID-19',
    planCoverage2: 'KEMALANGAN DIRI',
    coverage2sub1: 'Kematian akibat Kemalangan',
    coverage2sub2: 'Hilang Upaya Menyeluruh dan Kekal',
    coverage2sub3:
      'Kehilangan penglihatan pada sebelah atau kedua-dua belah mata dan/atau kehilangan satu atau lebih anggota',
    planCoverage3: 'PEMINDAHAN PERUBATAN KECEMASAN & REPATRIASI',
    coverage3sub1: 'Pemindahan/Repatriasi Perubatan Kecemasan*',
    coverage3sub2: 'Repatriasi Jenazah*',
    coverage3sub3:
      '*Had maksimum yang perlu dibayar untuk Pemindahan Perubatan Kecemasan dan Repatriasi Jenazah',
    planCoverage4: 'KESULITAN PERJALANAN & MANFAAT LAIN BERKAITAN PERJALANAN',
    coverage4sub1: 'Kehilangan Bagasi dan Barangan Peribadi',
    coverage4sub2: 'Kelewatan Bagasi',
    coverage4sub3: 'Wang & Dokumen Peribadi',
    coverage4sub4: 'Kelewatan Perjalanan',
    coverage4sub5: 'Laluan Perjalanan Diubah',
    coverage4sub6: 'Kehilangan Deposit atau Pembatalan',
    coverage4sub7: 'Pemendekan Perjalanan',
    coverage4sub8: 'Perjalanan Terlebih Tempahan',
    coverage4sub9: 'Kegagalan Menyambung Perjalanan',
    coverage4sub10: 'Rampasan Pesawat/Kenderaan',
    coverage4sub11: 'Ketinggalan Perlepasan',
    coverage4sub12:
      'Kehilangan Deposit atau Bayaran Penuh disebabkan Insolvensi Syarikat Penerbangan',
    coverage4sub13: 'Liabiliti Diri',
    inclusiveCoverage: '(Termasuk Perlindungan COVID-19)',
    delayCompensation: 'RM200.00 bagi setiap kelewatan 6 jam penuh berturut-turut',
    overbookedCompensation:
      'RM200.00 untuk setiap 6 jam penuh berturut-turut untuk syarikat penerbangan biasa yang terlebih tempahan dan tiada pengangkutan alternatif disediakan.',
    misconnectionCompensation:
      'RM200.00 jika tiada pengangkutan alternatif tersedia dalam tempoh 4 jam dari masa ketibaan sebenar.',
    hijackingCompensation: 'RM1,000.00 untuk setiap 24 jam penuh rampasan berturut-turut.',
  },
  domesticPlan: {
    foundPlans: 'Kami menemui 1 pelan yang paling sesuai dengan anda.',
    domestic: 'Dalam Malaysia',
    totalPrice: 'Jumlah Harga untuk',
    adult: 'Dewasa',
    adults: 'Dewasa',
    child: 'Kanak',
    children: 'Kanak-kanak',
    buyNow: 'Beli Sekarang',
    limitPerPerson: 'Had Setiap Orang',
    limitPerIndividual: 'Had Setiap Individu',
    upTo70Years: 'Sehingga 70 tahun',
    above70Years: '70 tahun ke atas',
    perDay: 'Sehari',
    perIndividual: 'Setiap Individu',
    planCoverage1: 'PERBELANJAAN PERUBATAN & LAIN-LAIN',
    coverage1sub1: 'Perbelanjaan Perubatan, Hospital & Lain-lain',
    coverage1sub2: 'Perubatan Alternatif*',
    coverage1sub3: 'Elaun Hospital',
    planCoverage2: 'KEMALANGAN DIRI',
    coverage2sub1: 'Kematian akibat Kemalangan',
    coverage2sub2: 'Hilang Upaya Menyeluruh dan Kekal',
    coverage2sub3:
      'Kehilangan penglihatan pada sebelah atau kedua-dua belah mata dan/atau kehilangan satu atau lebih anggota',
    planCoverage3: 'KESULITAN PERJALANAN & MANFAAT LAIN BERKAITAN PERJALANAN',
    coverage3sub1: 'Kehilangan Bagasi dan Kesan Peribadi',
    coverage3sub2: 'Kelewatan Bagasi',
    coverage3sub3: 'Kelewatan Perjalanan',
    coverage3sub4: 'Kehilangan Deposit atau Pembatalan',
    coverage3sub5:
      'Kehilangan Deposit atau Bayaran Penuh disebabkan Insolvensi Syarikat Penerbangan',
    inclusiveCoverage: '(Termasuk Perlindungan COVID-19)',
    delayCompensation: 'RM200.00 untuk setiap kelewatan 6 jam penuh berturut-turut',
  },
  error: {
    fieldRequired: 'Sila Isi Ruang Yang Berkenaan',
    invalidMobile: 'Sila isi nombor telefon bimbit yang sah',
    tickPolicyCondition: 'Sila tandakan jika anda memenuhi syarat polisi di atas',
    validEmail: 'Sila masukkan e-mel yang sah',
    validPostcode: 'Poskod tidak sah',
    invalidNRIC: 'NRIC tidak sah',
    nricMustMatchDOB: 'No. NRIC mesti sepadan dengan tarik lahir pelindung',
    duplicateID: 'ID pendua ditemui',
    coverAgeBelow: 'Kami hanya menawarkan perlindungan untuk umur di bawah 80 tahun sahaja',
    coverAgeAbove: 'Pemegang polisi hendaklah berumur 16 tahun dan ke atas',
    validUSMEmail: 'Sila masukkan e-mel USM yang sah',
    emailNotMatch: 'Alamat E-mel tidak sepadan.',
    remainingPercent: 'Sila lengkapkan baki',
    nomineePercent: 'Peratusan penama tidak mencapai 100%',
    incompleteNominee: 'Sila lengkapkan borang penama',
    failedAdd: 'Sila tambah penama sebelum meneruskan',
    amlaError:
      'Maaf, kami tidak dapat meneruskan transaksi anda. Sila hubungi Khidmat Pelanggan kami di +603 2170 7300, waktu operasi 8.30 pagi - 5.00 petang (Isnin hingga Jumaat) tidak termasuk cuti umum. Anda juga boleh menghantar e-mel ke customer@bsompo.com.my untuk mendapatkan bantuan lanjut.',
    amlaError2: 'Akaun pelanggan telah dibekukan, sila hubungi penyelia pemasaran anda.',
    nominationLimit: 'Had maksimum 2 untuk penamaan',
    nominationInsuredID: 'ID Penama dan ID Diinsuranskan tidak boleh sama',
    nominationIDSame: 'Kedua-dua ID Penama tidak boleh sama',
  },
  productLinks: {
    motorNow: 'https://online.berjayasompo.com.my/motorNow/Insurans-kereta/',
    sompoMotor: 'https://online.berjayasompo.com.my/SompoMotor/bm/',
    medicNow: 'https://online.berjayasompo.com.my/medicNow/insurans-perubatan/',
    motorcycle: 'https://online.berjayasompo.com.my/motorcycle/bm/',
    cashNow: 'https://online.berjayasompo.com.my/cashNow/insurans-pendapatan-hospital/',
    homeNow: 'https://online.berjayasompo.com.my/homeNow/insurans-kandungan-rumah/',
    travel: 'https://online.berjayasompo.com.my/securetravel/insurans-perjalanan/',
  },
  contact: {
    title: 'Perlukan bantuan? Hubungi Kami',
    description:
      'Jika anda mempunyai sebarang pertanyaan, sila hubungi Pusat Khidmat Pelanggan Berjaya Sompo Insurance Berhad di talian +603 2170 7300 dari 8.30 pagi sehingga 5 petang (Isnin hingga Jumaat – tidak termasuk Cuti Umum) atau emel ke banca.support@bsompo.com.my. Sebagai alternatif, anda boleh menghubungi CIMB Bank Berhad di talian +603 6204 7788, yang tersedia 24 jam, atau e-mel contactus@cimb.com.',
    registrationNo: 'Nombor Pendaftaran',
  },
  cross_sell: {
    title: 'Meliputi setiap bahagian setiap hari',
    desc: 'Ketahui lebih lanjut tentang produk insurans yang kami tawarkan',
    button_01: 'Dapatkan Sebut Harga',
    button_02: 'Dapatkan Sebut Harga',
    button_03: 'Dapatkan Sebut Harga',
    travel_title: 'Insurans Perjalanan',
    travel_01: 'Perbelanjaan Perubatan, Hospital & Lain-lain sehingga RM 500,000.',
    travel_02: 'Elaun Kuarantin Luar Negara Kerana COVID-19.',
    travel_03: 'Evakuasi & Repatriasi Perubatan Kecemasan.',
    travel_04: 'Kehilangan Deposit atau Pembatalan Penerbangan.',
    snatch_title: 'Snatch Medz+',
    snatch_01: 'Kematian Akibat Kemalangan sehingga RM600,000*.',
    snatch_02: 'Indemniti Berganda akibat Ragut atau Rompakan sehingga RM1,200,000*.',
    snatch_03: 'Perlindungan Pinjaman Kenderaan.',
    snatch_04: 'Tiada Bonus Pembaharuan Tuntutan.',
    home_title: 'Secure Home',
    home_01: 'Premium Serendah RM11/Sebulan.',
    home_02: 'Perlindungan Semua Risiko Termasuk Kebakaran, Banjir & Banyak Lagi.',
    home_03: 'Pilihan Pelbagai Pelan dengan Perlindungan Sehingga RM60,000.',
    home_04: 'Pengisytiharan Kandungan Rumah Tidak Diperlukan.',
    securemotor_title: 'Secure Motor',
    securemotor_01: 'Nilai Dipersetujui',
    securemotor_02: 'Percuma Perlindungan Peril Khas',
    securemotor_03: 'Perlindungan untuk Semua Pemandu',
    securemotor_04: 'Waranti Pembaikan 12 Bulan',
    securemotor_05: 'Bantuan Tepi Jalan 24 Jam',
  },
  disclaimer: {
    line_01:
      'Nota : Anda berada di laman web Berjaya Sompo Insurance Berhad, dasar privasi CIMB Group tidak terpakai.',
    line_02: 'Penafian',
    line_03:
      'Deskripsi ciri dan manfaat yang dilampirkan pada produk insurans ini bukan kontrak insurans tetapi hanyalah ringkasan produk insurans bagi tujuan rujukan. Terma dan syarat lengkap produk insurans terkandung di dalam Dokumen Polisi Berjaya Sompo Insurance Berhad (No. Pendaftaran 198001008821 (62605-U)), Syarikat Insurans.',
    line_04:
      'CIMB Bank Berhad ("Bank") tidak bertanggungjawab, bersetuju atau memegang liabiliti untuk produk insurans dan perkhidmatan yang diberikan oleh Syarikat Insurans.',
    line_05: 'Pihak Bank hanya berfungsi sebagai pengedar untuk produk insurans ini.',
    line_06:
      'Produk insurans ini adalah hak milik Berjaya Sompo Insurance Berhad dan bukan produk kepunyaan pihak Bank. Bermaksud produk insurans ini tiada jaminan dari pihak Bank, syarikat subsidiari atau ahli gabungan dan Syarikat Insurans perlu sepenuhnya bertanggungjawab, bersetuju dan memegang liabiliti untuk produk insurans ini.',
  },
  header: {
    cs: 'Berjaya Sompo Khidmat Pelanggan',
    tel: '+603 2170 7300 (8:30 AM - 5:00 PM - Monday to Friday)',
    email: 'banca.support@bsompo.com.my',
    cs2: 'CIMB Khidmat Pelanggan',
    tel2: '+603 6204 7788 (24 Hours)',
    email2: 'contactus@cimb.com',
  },
  footer: {
    title: 'Pengaki',
    onlineProduct: 'PRODUK DALAM TALIAN',
    onlineCarIns: 'Insurans Kereta Dalam Talian',
    onlineMotorCycleIns: 'Insurans Motosikal Dalam Talian',
    onlineTravelIns: 'Insurans Perjalanan Dalam Talian',
    onlineCashNowIns: 'Insurans Pendapatan Hospital Dalam Talian',
    onlineMedicNowIns: 'Insurans Perubatan & Kesihatan Dalam Talian',
    onlineHomeNowIns: 'Insurans Kandungan Rumah Dalam Talian',
    keyDownload: 'MUAT TURUN UTAMA',
    pds: 'Lembaran Pendedahan Produk (Single)',
    pwt: 'Susunan Kata Polisi (Single)',
    pdsAnnual: 'Lembaran Pendedahan Produk (Annual)',
    pwtAnnual: 'Susunan Kata Polisi (Annual)',
    eBrochure: 'e-Brosur',
    contactUs: 'HUBUNGI KAMI',
    webForm: 'Borang Penamaan Benefisiari',
    address: 'Alamat',
    cs: 'Khidmat Pelanggan',
    time: '8:30 PG - 5:00 PTG (Isnin hingga Jumaat)',
    tel1: '1 800 889 933 (dalam Malaysia)',
    tel2: '+603 2170 7300 (luar negara)',
    worldWideAssistance: 'Bantuan 24/7 Seluruh Dunia',
    breakDownForPrivateCar: 'Servis Kerosakan 24/7 untuk Kereta Persendirian',
    breakDownForMotorcycle: 'Servis Kerosakan 24/7 untuk Motosikal',
  },
  destination: {
    area: "Kawasan",
    excludeTibetMongolia: "kecuali Tibet dan Outer Mongolia",
    areaDesc2: "Seluruh dunia <strong>tidak termasuk</strong> USA & Canada.",
    areaDesc3: "Seluruh dunia <strong>termasuk</strong> USA & Canada.",
  },
  generalErrorMessage: generalErrorMessage,
  errorMessages: [
    {
      apiError: 'general',
      message: generalErrorMessage,
    },
    {
      apiError: 'ISM Connectivity Error',
      message: generalErrorMessage,
    },
    {
      apiError: '[INVALID PERMANENT POST CODE]',
      message: 'Invalid Post Code!',
    },
    {
      apiError: 'UW Policy holder Age Referred',
      message: generalErrorMessage,
    },
    {
      apiError: 'POLICY LAPSED DAYS SHOULD NOT BE MORE THAN 14 DAYS',
      message: generalErrorMessage,
    },
    {
      // TP to comprehensive
      apiError:
        '1 - Scope of Cover changed from Third Party to Comprehensive Referred $$UW Sum Insured Referred',
      message: generalErrorMessage,
    },
    {
      apiError: 'UW Sum Insured Referred',
      message: generalErrorMessage,
    },
    {
      // a case of high perf vehicle got this error
      apiError: 'MAKE MODEL MISSING',
      message: generalErrorMessage,
    },
    {
      apiError: 'sessionExpired',
      message: 'Your session has expired. Please retry from beginning',
    },
    {
      apiError: 'POLICY SHOULD BE LESS THAN 60 DAYS TO TAKE THE EARLIER POLICY',
      message: 'POLICY SHOULD BE LESS THAN 60 DAYS TO TAKE THE EARLIER POLICY',
    },
    {
      apiError: 'INVALID VEHICLE MAKE MODEL',
      message: 'INVALID VEHICLE MAKE MODEL',
    },
    {
      apiError: 'Pricing Field Error',
      message: (
        <>
          We are currently unable to process your quotation. Please try quoting at our alternate
          site at{' '}
          <a href="https://customer.berjayasompo.com.my/directsales/motor-cycle/">
            https://customer.berjayasompo.com.my/directsales/motor-cycle/
          </a>
        </>
      ),
    },
  ],
  travelInsurance: 'Insurans Perjalanan',
  home: 'Laman Utama',
  howToClaim: 'Cara Menuntut',
  contactUs: 'Hubungi Kami',
  partnerWithUs: 'Bekerjasama Dengan Kami',
  faq: 'Soalan Lazim',
  faqLink: '/articles/insurans-perjalanan-soalan-lazim',
  homeLink: 'https://online.berjayasompo.com.my/securetravel/insurans-perjalanan/',
  partnerWithUsLink: 'https://travel.berjayasompo.com.my/securetravel/highlights/partnerBM.html',
  onlineProduct: 'Produk Dalam Talian',
  extraCoverage: 'EXTRA COVERAGE FOR POST COVID-19 VACCINATION AT NO COST (NEW)',
  homeBannerWord:
    'Teruskan semula pelan perjalanan anda dan dapatkan perlindungan daripada COVID-19 dengan kami.',
  travellingOverseas: 'Luar Negara',
  domestic: 'Domestik',
  annual: 'Pelan Tahunan',
  enterDestination: 'Masukkan semua destinasi',
  withinMalaysia: 'Dalam Malaysia',
  depart: 'Bertolak dari Malaysia',
  return: 'Pulang ke Malaysia',
  emailAddress: 'Alamat E-mel',
  adult: 'Dewasa',
  child: 'Kanak',
  individualGroup: 'Individu / Kumpulan', //  / Keluarga
  travellerTooltip:
    'Semua individu yang diinsuranskan berumur antara 16 tahun dan 80 tahun (termasuk kedua-dua umur ). Orang yang diinsuranskan dalam kumpulan mestilah berumur antara 16 tahun dan 80 tahun bagi pihak utama yang diinsuranskan; 30 hari hingga 80 tahun bagi pihak kedua yang diinsuranskan  dan seterusnya. Minimum 2 orang dan maksimum 20 orang yang boleh diinsuranskan dalam perjalanan yang sama.',
  getQuote: 'Dapatkan Sebut Harga Insurans Perjalanan',
  declaration:
    'Saya adalah Warganegara Malaysia/Pemastautin Tetap, atau pemegang permit kerja yang sah, pas tanggungan atau visa pelajar di Malaysia.',
  domesticNotification:
    'Untuk Pelan Perjalanan Domestik, perlindungan untuk COVID-19 hanya terpakai untuk Perjalanan dengan syarikat penerbangan berjadual.',
  tnc:
    "Dengan mengklik butang 'Dapatkan Sebut Harga Insurans Perjalanan', anda telah membaca dan bersetuju dengan",
  tncpn: 'Notis Privasi',
  step1: 'Langkah 1',
  step2: 'Langkah 2',
  step3: 'Langkah 3',
  plan: 'Pelan',
  details: 'Butiran',
  payment: 'Bayaran',
  buyNow: 'Beli Sekarang',
  viewBenefits: 'Lihat semua manfaat',
  emailQuote: 'E-mel sebut harga',
  editQuote: 'Ubah sebut harga',
  policyHolderDetails: 'Butiran Pemegang Polisi',
  adultChild: 'Dewasa / Kanak-kanak',
  fillDetails: 'Sila isikan butiran anda di bawah',
  name: 'Nama (Mengikut NRIC/Pasport)',
  nationality: 'Kewarganegaraan',
  nricPassport: 'NRIC/Passport/Lain-Lain',
  passportOther: 'Passport/Lain-lain',
  dob: 'Tarikh Lahir',
  malaysianPassport: 'Passport Malaysia (Pilihan)',
  confirmEmailAddress: 'Sahkan Alamat E-mel',
  phoneNo: 'No. Telefon',
  address: 'Alamat',
  address1: 'Alamat 1',
  address2: 'Alamat 2',
  postcode: 'Poskod',
  addCity: 'Bandar',
  addState: 'Negeri',
  nomineeDetails: 'Butiran Penama (Pilihan)',
  nominee: 'Penama',
  nomineeName: 'Nama penama',
  requiredField: 'Maklumat ini diperlukan',
  nomineeNRIC: 'NRIC/Pasport/Lain-lain*',
  nomineeRelationship: 'Hubungan',
  nomineePercentage: 'Peratus',
  add: 'Tambah',
  resetForm: 'Set Semula',
  quotationSummary: 'Ringkasan Sebut harga',
  typeOfPlan: 'Jenis Pelan',
  insurancePeriod: 'Tempoh Insurans',
  grossPremium: 'Premium Kasar',
  rebate: 'Rebat',
  serviceTax: 'Cukai Perkhidmatan',
  grossPremiumAfterRebate: 'Premium Kasar Selepas Rebat',
  stampDuty: 'Duti Setem',
  totalPremium: 'Jumlah Premium',
  commissionToIntermediary: 'Termasuk 25% komisen kepada pengantara insurans',
  summaryPayment: 'Ringkasan & Pembayaran',
  infoConfirmation: 'Sila semak dan sahkan maklumat di bawah',
  paymentDeclaraction1_1: 'Saya/Kami telah membaca, memahami dan mengakui ',
  pds: 'Lembaran Pendedahan Produk',
  paymentDeclaraction1_2: ' dan ',
  pn: 'Notis Privasi',
  paymentDeclaraction1_3:
    ' dan dengan ini membenarkan penggunaan dan pemprosesan data peribadi saya/kami oleh Kumpulan Syarikat Sompo dan Kumpulan Syarikat Berjaya (di dalam atau di luar Malaysia) untuk tujuan tersebut seperti yang diterangkan dalam Notis Privasi.',
  paymentDeclaraction2:
    'Saya/Kami dengan ini mengakui bahawa semua maklumat yang diberikan adalah benar dan saya/kami tidak menyimpan sebarang maklumat yang mungkin mempengaruhi penerimaan cadangan ini. Saya/Kami mengakui bahawa terma kontrak utama telah dijelaskan dengan secukupnya kepada saya/kami dan saya/kami memahami sepenuhnya terma tersebut. Saya/kami berpuas hati bahawa produk tersebut memenuhi keperluan insurans saya/kami dan kemampuan kewangan.',
  acceptTnC: 'Saya/Kami menerima terma dan syarat',
  pleaseAcceptTnC: 'Sila terima terma dan syarat',
  marketingConsent:
    'Saya/Kami dengan ini memberikan kebenaran saya kepada Berjaya Sompo Insurance Berhad untuk berkongsi maklumat saya/kami (tidak termasuk maklumat yang berkaitan dengan hal ehwal atau akaun saya/kami) dengan CIMB Bank Berhad untuk tujuan pemasaran dan promosi mereka.',
  yes: 'Ya',
  no: 'Tidak',
  tncAgree: 'Sila bersetuju dengan terma sebelum meneruskan',
  onlineBanking: 'Perbankan atas talian',
  creditCard: 'Kad Kredit',
  eWallet: 'eWallet',
  next: 'Seterusnya',
  back: 'Kembali',
  payNow: 'Bayar Sekarang',
  paymentSuccess: 'Pembayaran Berjaya',
  thankYouPayment:
    'Terima kasih kerana memilih pelan insurans Secure Travel. Pembayaran anda telah berjaya diproses',
  failedPayment:
    'Terima kasih kerana memilih pelan insurans Secure Travel. Akan tetapi, pembayaran anda tidak berjaya. Sila cuba membuat bayaran semula.',
  transactionDetails: 'Butiran Transaksi',
  transactionNo: 'No. Transaksi',
  transactionDate: 'Tarikh Transaksi',
  paymentMethod: 'Kaedah Pembayaran',
  totalAmount: 'Jumlah Keseluruhan',
  paymentName: 'Nama',
  typeOfPlan: 'Jenis Pelan',
  policyNo: 'No. Polisi',
  paymentFailed: 'Pembayaran Tidak Berjaya',
  paymentRetry: 'Bayar Sekali',
  periodOfCover: 'Tempoh Perlindungan',
  to: 'sampai',
  policyEmailPre: 'Salinan resit dan Jadual Polisi anda akan dihantar ke alamat e-mel anda di',
  policyEmailPost:
    'Sila semak folder e-mel sampah atau spam jika anda tidak menerima dokumen dalam peti masuk anda.',
  crossCar: 'https://online.berjayasompo.com.my/securemotor/insurans-kereta/',
  crossCarImage: '/securetravel/images/img-cross-motor-bm.jpg',
  crossMotor: 'https://online.berjayasompo.com.my/motorcycle/bm/',
  crossMotorImage: '/securetravel/images/img-cross-motorcycle-bm.jpg',
  crossTravel: 'https://online.berjayasompo.com.my/securetravel/insurans-perjalanan/',
  crossTravelImage: '/securetravel/images/img-cross-travel-bm.jpg',
  crossHome: 'https://customer.berjayasompo.com.my/directsales/sh?account_code=10006833#/',
  crossHomeImage: '/securemotor/images/img-cross-home.jpg',
  campaignTncText:
    'GrabGifts e-vouchers will be fulfilled via email within 45 days after the campaign ends on 31 December 2023 if you meet the campaign eligibility requirements.',
  downloadCI: 'Muat Turun Polisi',
  downloadDesc:
    'Anda juga boleh memuat turun resit dan jadual polisi pada butang muat turun di atas. Sila ambil perhatian bahawa pautan butang muat turun akan tamat tempoh dalam masa 15 minit.',
  downloadDesc2:
    'Untuk membuka fail, sila gunakan format kata laluan berikut: parap pertama nama anda (seperti yang dinyatakan dalam polisi) dalam huruf besar, diikuti dengan 6 digit terakhir nombor NRIC/Pasport anda.',
  downloadDesc3:
    'Contohnya: Jika nama anda ialah John dan 6 digit terakhir NRIC anda adalah 141234, kata laluan anda ialah J141234.',
}
